'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Map = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Map = require('components/Sell/MapSection/Map');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_CLUSTERING_RADIUS = 1; /* globals L */

var Map = exports.Map = function (_Component) {
  (0, _inherits3.default)(Map, _Component);

  function Map(props) {
    (0, _classCallCheck3.default)(this, Map);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Map.__proto__ || (0, _getPrototypeOf2.default)(Map)).call(this, props));

    _this.$map = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(Map, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var map = this.getCurrentLeaflet();
      map.removeControl(map.zoomControl);
      map.dragging.disable();
      if (L.control) {
        var credits = L.control.attribution().addTo(map);
        credits.addAttribution('© <a href="https://www.mapbox.com/about/maps/" rel="nofollow">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright" rel="nofollow">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank" rel="nofollow">Improve this map</a></strong>');
      }
    }
  }, {
    key: 'getCurrentLeaflet',
    value: function getCurrentLeaflet() {
      return this.$map.current.leafletElement;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          venues = _props.venues,
          mapBounds = _props.mapBounds;


      return _react2.default.createElement(
        'div',
        { className: 'map--blue explore-map-v1__map' },
        _react2.default.createElement(
          'a',
          { href: 'http://mapbox.com/about/maps', className: 'explore-map-v1__map__wordmark', rel: 'nofollow' },
          'Mapbox'
        ),
        (__CLIENT__ || __TEST__) && _react2.default.createElement(_Map.Map, {
          ref: this.$map,
          defaultBounds: mapBounds,
          studiosData: venues,
          clusterOptions: {
            markers: {
              iconSize: [35, 35],
              iconAnchor: [17.5, 35]
            },
            maxClusterRadius: DEFAULT_CLUSTERING_RADIUS,
            disableClusteringAtZoom: 18,
            showCoverageOnHover: false,
            spiderfyOnMaxZoom: false
          }
        })
      );
    }
  }]);
  return Map;
}(_react.Component);

Map.propTypes = {
  venues: _propTypes2.default.array,
  mapBounds: _propTypes2.default.object
};